import { MapContainer, Marker, Popup, TileLayer, ZoomControl, LayersControl, LayerGroup, useMap } from 'react-leaflet';
import axiosPublic from '../axios_public';
import React, { useState, useEffect, useMemo, useContext } from 'react';
import 'esri-leaflet-geocoder/dist/esri-leaflet-geocoder.css';
import Wkt from 'wicket';
import { myIconCPT, myIconCPTU, myIconCPTE, myIconDMT, myIconSDMT, myIconSONDAGGIO, myIconHVSR, myIconMASW, myIconDH, icon, myIconPoz,myIconDin,myIconIdr, myIconOff,myIconCH,myIconArray, myIconRemi } from '../custom_icon';
import LeafletRuler from "../LeafletRuler";
import MarkerClusterGroup from "react-leaflet-markercluster";
import "react-leaflet-markercluster/dist/styles.min.css";
import { OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch';
import "leaflet-geosearch/dist/geosearch.css";
import { useNavigate } from 'react-router-dom';
import '../components/MapComponent.css';
import { DataContext } from '../context/DataContext';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { WMSTileLayer } from 'react-leaflet';
import L from 'leaflet';
import { useMapEvents } from 'react-leaflet';

// Componente per gestire eventi della mappa
const MapEvents = ({ onMoveEnd }) => {
  const map = useMap();
  const [lastBbox, setLastBbox] = useState(null);

  useEffect(() => {
    if (!onMoveEnd) return;

    const handleMoveEnd = () => {
      const bounds = map.getBounds();
      const bbox = [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()];

      // chiama onMoveEnd solo se bbox è cambiato
      if (!lastBbox || bbox.some((val, i) => Math.abs(val - lastBbox[i]) > 1e-6)) {
        setLastBbox(bbox);
        onMoveEnd(map);
      }
    };

    map.on('moveend', handleMoveEnd);

    // caricamento iniziale
    handleMoveEnd();

    return () => map.off('moveend', handleMoveEnd);
  }, [map, onMoveEnd, lastBbox]);

  return null;
};

function LeafletgeoSearch() {
  const map = useMap();

  useEffect(() => {
    const provider = new OpenStreetMapProvider();
    const searchControl = new GeoSearchControl({ provider, marker: { icon } });
    map.addControl(searchControl);
    return () => map.removeControl(searchControl);
  }, [map]);

  return null;
}

const FilteredMarkers = ({ points, filters, icons }) => {
  const filteredPoints = useMemo(() => {
    return points.filter(point => filters.includes(point.tipo));
  }, [points, filters]);

  return (
    filteredPoints.map((point, i) => {
      const icon = icons[point.tipo];
      return (
        <Marker key={i} position={[point.coords[1], point.coords[0]]} icon={icon}>
          <Popup>
            ID: {point.id} <br />
            Tipologia: {point.tipo} <br />
             {point.link && (
              <>
                <a
                  href={point.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#2cb8b5", fontWeight: "bold" }}
                >
                  Consulta dati
                </a>
                <br />
              </>
            )}
          </Popup>
        </Marker>
      );
    })
  );
};

const buttonStyle = {
  fontFamily: 'roboto',
  fontSize: '11px',
  border: '2px solid #12455b',
  color: 'black',
  padding: '5px 16px',
  cursor: 'pointer',
  borderRadius: '12px',
  backgroundColor: 'white',
  marginTop: '3px'
};



export const MapComponentOL = ({ positionDefault = [44.36, 11.34], filters }) => {

  const [geopoints, setGeopoints] = useState([]);
  const [loading, setLoading] = useState({ loadingGeo: false, loadingSIS: false });
  const [geoLayerActive, setGeoLayerActive] = useState(false)
  const navigate = useNavigate();

  // Funzione per caricare dati nel bbox della mappa
  const renderGeoData = async (mapInstance) => {
      if (!mapInstance || !mapInstance.getBounds) return;

      setLoading(prev => ({ ...prev, loadingGeo: true }));

      const bounds = mapInstance.getBounds();
      const bbox = [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()];

      try {
        const url = `https://hat.sofhare.com/regis/?bbox=${bbox.join(',')}`;
        const response = await axiosPublic.get(url);

        // FIXED: Check if response.data is an array directly
        if (!response.data || !Array.isArray(response.data)) {
          console.error("Invalid response structure:", response.data);
          setGeopoints([]);
          return;
        }

        const allData = response.data.map(item => {
          // Add safety checks for item properties
          if (!item.geom) {
            console.warn("Item missing geom property:", item);
            return null;
          }

          const wkt_geom = item.geom.replace('SRID=4326;', '');
          const wkt = new Wkt.Wkt();
          wkt.read(wkt_geom);
          const geojson_geom = wkt.toJson();

          return {
            coords: geojson_geom.coordinates,
            id: item.gid || 'N/A',
            tipo: item.tipo_prova || 'unknown',
            link: item.link || null
          };
        }).filter(item => item !== null); // Filter out null items

        setGeopoints(allData);
      } catch (error) {
        // Improved error handling
        console.error("Error fetching GEO data:",
          error.response?.data ||
          error.message ||
          error.request ||
          'Unknown error occurred'
        );

        // Optionally set an empty array or error state
        setGeopoints([]);
      } finally {
        setLoading(prev => ({ ...prev, loadingGeo: false }));
      }
  };



  const geoIcons = {
    CPT: myIconCPT,
    CPTU: myIconCPTU,
    CPTE: myIconCPTE,
    DMT: myIconDMT,
    SDMT: myIconSDMT,
    DIN:myIconDin,
    SONDAGGIO: myIconSONDAGGIO,
    SONDAGGIO_IDROCARBURI: myIconIdr,
    SONDAGGIO_OFFSHORE: myIconOff,
    HVSR: myIconHVSR,
    MASW: myIconMASW,
    REMI:myIconRemi,
    DH: myIconDH,
    CH: myIconCH,
    ARRAY_SISMICO: myIconArray,
    POZZO: myIconPoz,
  };


  function getFeatureInfoUrl(map, baseUrl, layer, latlng) {
      const size = map.getSize();
      const bounds = map.getBounds();
      const point = map.latLngToContainerPoint(latlng, map.getZoom());

      // 🔥 WMS 1.3.0 + EPSG:4326 => axis order (LAT, LON)
      const bbox = [
        bounds.getSouth(), // lat min
        bounds.getWest(),  // lon min
        bounds.getNorth(), // lat max
        bounds.getEast()   // lon max
      ].join(",");

      const params = {
        service: "WMS",
        request: "GetFeatureInfo",
        version: "1.3.0",
        layers: layer,
        query_layers: layer,
        styles: "",

        bbox,

        width: size.x,
        height: size.y,

        format: "image/png",

        // 🔥 più compatibile con ESRI WMS
        info_format: "text/html",

        crs: "EPSG:4326",

        // 🔥 coordinate pixel corrette
        i: Math.floor(point.x),
        j: Math.floor(point.y),
      };

      return baseUrl + L.Util.getParamString(params, baseUrl, true);
    }

    function GeoInfoClick({ active }) {
      const map = useMap();

      useEffect(() => {
        if (!map) return;

        const handleClick = async (e) => {

          // 🔥 CONTROLLO REALE DEL LAYER
          const wmsLayerActive = Object.values(map._layers || {}).some(layer =>
            layer?.options?.layers === "Unita_geol_10k"
          );

          if (!wmsLayerActive) {
            console.log("WMS layer NON attivo → click ignorato");
            return;
          }

          const url = getFeatureInfoUrl(
            map,
            "https://servizigis.regione.emilia-romagna.it/wms/geologia10k",
            "Unita_geol_10k",
            e.latlng
          );

          try {
            const res = await fetch(url);
            const text = await res.text();

            L.popup()
              .setLatLng(e.latlng)
              .setContent(text || "Nessun dato")
              .openOn(map);
          } catch (err) {
            console.error(err);
          }
        };

        map.on("click", handleClick);
        return () => map.off("click", handleClick);
      }, [map]);
      return null;
    }

  return (
    <div className="general">
    <div id="legendContainer"></div>
      <div className='map1'>
        <a href="/#" id="downloadAnchorElem" style={{ display: "none" }}>a</a>
        <MapContainer center={positionDefault} zoom={13} minZoom={12} maxZoom={18} zoomControl={false} style={{ height: '100%', width: '100%' }}>

          <LayersControl position="topright">
            <LayersControl.BaseLayer checked name="OpenStreetMap.HOT">
              <TileLayer
                url='https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png'
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="Esri.WorldImagery">
              <TileLayer
                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                attribution='&copy; <a href="https://www.esri.com/en-us/arcgis/products/arcgis-online/overview">Esri</a>'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="OpenStreetMap">
              <TileLayer
                url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer name="OpenTopoMap">
              <TileLayer
                url='https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png'
                attribution='&copy; <a href="https://opentopomap.org">OpenTopoMap</a> contributors'
              />
            </LayersControl.BaseLayer>

            <LayersControl.Overlay  unchecked name="Vs,eq Distribuitions" >
                        <TileLayer
                            url='https://repository.sofhare.com/mappe/vseq/{z}/{x}/{y}.png'
                            attribution='sofHare © 2023 Vs,eq Distribuitions '
                            opacity={0.5}
                            eventHandlers={{
                              add: (e) => {
                                console.log("Added Layer:", e.target);
                                // Create a legend element with colors
                                const legend = document.createElement('div');

                                legend.style.position = 'absolute';


                                legend.style.zIndex = 3000;
                                legend.style.display = 'flex';
                                const items = [
                                {color:'rgba(48, 18, 59, 0.5)',label:'50'},
                                 {color:'rgba(35, 193, 217, 0.5)'},
                                 {color:'rgba(86, 245, 100, 0.5)',label:'180'},
                                  {color:'rgba(202, 243, 79, 0.5)'},
                                  {color:'rgba(227, 203, 50, 0.5)',label:'300'},
                                  {color:'rgba(255, 90, 0, 0.5)'},
                                   {color:'rgba(205, 50, 6, 0.5)',label:'360'},
                                    {color:'rgba(122, 4, 3, 0.5)'}];

                                items.forEach((item,index) => {
                                  const legendItem = document.createElement('div');
                                  legendItem.style.display = 'flex'; // Display label and color box horizontally
                                  legendItem.style.flexDirection = 'column';
                                  legendItem.style.alignItems = 'center'; // Align items vertically in the center
                                  const colorBox = document.createElement('div');
                                  colorBox.style.backgroundColor = item.color;
                                  colorBox.style.width = '30px';
                                  colorBox.style.height = '15px';
                                  //colorBox.style.marginRight = '10px'; // Adjust the margin between color box and label
                                  legendItem.appendChild(colorBox);
                                  const label = document.createElement('div');
                                  label.textContent = item.label;
                                  label.style.alignItems = 'left';
                                  label.style.fontSize = '12px';
                                  label.style.fontWeight = "bold";
                                  legendItem.appendChild(label);
                                  legend.appendChild(legendItem);

                                });
                                // Append the legend to a container element
                                const container = document.getElementById('legendContainer'); // Replace 'legendContainer' with the actual ID of your container element
                                if (container) {
                                  container.appendChild(legend);
                                }
                                e.target.legend = legend;
                              },
                              remove: (e) => {
                                console.log("Removed layer:", e.target);
                                if (e.target && e.target.legend) {
                                const legend = e.target.legend;
                                console.log("Accessed legend:", legend);

                                // Remove the legend element from the container
                                legend.parentNode.removeChild(legend);

                                // Remove the legend property from the target
                                delete e.target.legend;
                              } else {
                                console.log("Legend is not properly stored or accessed.");
                                }
                              }
                           }}
                        />

                        </LayersControl.Overlay>

                        <LayersControl.Overlay
                          name="Carta Geologica 1:10k (ER)"
                          eventHandlers={{
                            add: () => setGeoLayerActive(true),
                            remove: () => setGeoLayerActive(false)
                          }}
                        >
                          <WMSTileLayer
                          url="https://servizigis.regione.emilia-romagna.it/wms/geologia10k"
                          layers="Unita_geol_10k"
                          format="image/png"
                          transparent={true}
                          opacity={0.6}
                          interactive={false}   // 🔥 QUESTO È IL FIX
                        />
                        </LayersControl.Overlay>

              <LayerGroup>
                <MarkerClusterGroup>
                  <FilteredMarkers points={geopoints} filters={Object.keys(filters).filter(key => filters[key])} icons={geoIcons}  />
                </MarkerClusterGroup>
              </LayerGroup>
          </LayersControl>
          <LeafletRuler />
          <ZoomControl position="bottomright" />
          <LeafletgeoSearch />
          <MapEvents onMoveEnd={renderGeoData} />
          <GeoInfoClick active={geoLayerActive} />

        </MapContainer>
      </div>

      {(loading.loadingGeo ) && (
        <div className="loading-indicator">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      )}
    </div>
  );
};








